import { useCallback, useState } from "react";
import { Alert, isHandledType } from "../../redux/alerts";
import { ResidentActivityType } from "../../redux/residentActivityPlan";
import { Dispatcher, RootDispatcher } from "../../service/RootDispather";
import { useStateRef } from "../../utils/hooks/hooks";

import { NotificationState } from "../../redux/newNotification/types";
import { ShowActions } from "./Monitor";

export enum ModalTypes {
  CANCEL = "CANCEL",
  SHOW_ACTIVITY_FEEDBACK = "show_ACTIVITY_FEEDBACK",
  SHOW_ALERT_FEEDBACK = "show_ALERT_FEEDBACK",
  SHOW_DEVICES_STATUSES = "show_DEVICES_STATUSES",
  SHOW_RESIDENT_STATUSES = "show_RESIDENT_STATUSES",
  SHOW_FULL_RESIDENT_CARD = "show_FULL_RESIDENT_CARD",
  SHOW_USER_NEAR_ROOM_STATUSES = "show_USER_NEAR_ROOM_STATUSES",
  BACK = "BACK",
  CONFIRM_DONE = "confirm_DONE",
}
export const useMonitorResidentsCallbacks = () => {
  const rootDispatcher = Dispatcher();
  const [modalComponent, setModalComponent] = useStateRef(null);
  const [modalType, setModalType] = useState(null);
  const [modalComponentsStack] = useState([]);
  const callback: (...args: any) => void = useCallback(
    (eventType: ModalTypes, ...args) => {
      if (eventType === ModalTypes.SHOW_ALERT_FEEDBACK) {
        const alert: Alert = args[0];
        if (isHandledType(alert.alertToken)) {
          const component = ShowActions(eventType, callback, true, args[0]);
          setModalComponent(component);
          setModalType(eventType);

          modalComponentsStack.push({ eventType, args });
        } else {
          rootDispatcher.notificationConfirm({
            residentId: alert.patientId,
            state: NotificationState.confirm,
            type: alert.alertToken,
            datetime: alert.lastUpdate,
          });
        }
      } else if (eventType === ModalTypes.SHOW_ACTIVITY_FEEDBACK) {
        if (args[0].activityType === ResidentActivityType.CLEANING)
          rootDispatcher.sendResidentActivity({
            residentId: args[1],
            activityType: args[0]?.activityType,
            feedback: null,
          });
        else {
          const component = ShowActions(eventType, callback, true, args);
          setModalComponent(component);
          setModalType(eventType);

          modalComponentsStack.push({ eventType, args });
        }
      } else if (eventType === ModalTypes.CANCEL) {
        while (modalComponentsStack.length > 0) modalComponentsStack.pop();
        setModalComponent(null);
      } else if (eventType === ModalTypes.BACK) {
        if (modalComponentsStack.length > 1) {
          modalComponentsStack.pop(); //remove me
          const data = modalComponentsStack.pop();
          const newTop = ShowActions(
            data.eventType,
            callback,
            modalComponentsStack.length > 0,
            data.args
          );
          modalComponentsStack.push(data);
          setModalComponent(newTop);
        } else {
          modalComponentsStack.pop(); //remove me
          setModalComponent(null);
        }
      } else if (eventType.indexOf("show") !== -1) {
        const component = ShowActions(
          eventType as ModalTypes,
          callback,
          modalComponentsStack.length > 0,
          args
        );

        setModalComponent(component);
        setModalType(eventType);

        modalComponentsStack.push({ eventType, args });
      } else if (eventType.indexOf("confirm") !== -1) {
        confirmActions(eventType, rootDispatcher, args);
        if (
          false
          //   eventType === ModalTypes.CONFIRM_DELETE_RESIDENT ||
          //   eventType === ModalTypes.CONFIRM_ADD_RESIDENT ||
          //   eventType === ModalTypes.CONFIRM_ADD_MANY_RESIDENT ||
          //   eventType === ModalTypes.CONFIRM_MOVE_RESIDENTS ||
          //   eventType === ModalTypes.CONFIRM_MOVE_RESIDENTS_WITH_DEVICES
        ) {
          while (modalComponentsStack.length > 0) modalComponentsStack.pop();
          setModalComponent(null);
        } else {
          if (modalComponentsStack.length > 1) {
            modalComponentsStack.pop(); //remove me
            const data = modalComponentsStack.pop();
            modalComponentsStack.push(data);
            const newTop = ShowActions(
              data.eventType,
              callback,
              modalComponentsStack.length > 0,
              data.args
            );
            setModalComponent(newTop);
          } else {
            modalComponentsStack.pop(); //remove me
            setModalComponent(null);
          }
        }
      }
    },
    [modalComponentsStack, rootDispatcher, setModalComponent]
  );

  const onClose = useCallback(() => {
    setModalComponent(null);
    while (modalComponentsStack.length > 0) modalComponentsStack.pop();
  }, [setModalComponent, modalComponentsStack]);

  return {
    callback,
    modalComponent,
    modalType,
    onClose,
  };
};

export const confirmActions = (
  eventType: string,
  rootDispatcher: RootDispatcher,
  args: any
): void => {};
